var render = function render(){var _vm=this,_c=_vm._self._c;return _c('icon',{style:({ fill: _vm.iconColor })})
}
var staticRenderFns = []

export { render, staticRenderFns }